import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const workPlaceApiUrl = `${baseApiUrl}/api/WorkPlaces`;

export async function getWorkPlaces() {
return await httpRequest(fetchWorkPlaces.bind(this));
}

async function fetchWorkPlaces() {
let config = getHttpHeaders();
return await axios.get(`${workPlaceApiUrl}`, config);
}
